
function getSearchParameters() {
    var prmstr = window.location.search.substr(1);
    return prmstr != null && prmstr != "" ? transformToAssocArray(prmstr) : {};
}

function transformToAssocArray(prmstr) {
    var params = {};
    var prmarr = prmstr.split("&");
    for (var i = 0; i < prmarr.length; i++) {
        var tmparr = prmarr[i].split("=");
        params[tmparr[0]] = tmparr[1];
    }
    return params;
}

const API_URL = "https://merchstore-api.cf-deployments.org/api/tag"


$(document).ready(function () {

    console.log("loading verification")

    const current_url = window.location.href
    const asset_name = current_url.split('/')[5].split('?')[0]
    const dom_el = $("#verification_feedback")

    if (asset_name.startsWith('HOODIE')) {

        var params = getSearchParameters();

        params['asset_name'] = asset_name

        if(typeof params.picc_data == "string" && typeof params.enc  == "string"  && typeof params.cmac  == "string" ){
          $.ajax({
              contentType: 'application/json',
              data: JSON.stringify(params),
              dataType: 'json',
              success: function(data){

                  if(data.status == "OK"){
                    $("#verification_status").text('Verified! ✅')
                    //$("#asset_video").attr('src', 'https://nftstorage.link/ipfs/' + data.asset.image.replace('ipfs://',''))

                    console.log(data.asset)

                    let video_source = null;
                    let poster_source = null;


                    if(data.asset.version == 1){
                      video_source = 'https://merchstore-api.cf-deployments.org/video/hoodie'
                      poster_source = "https://nftstorage.link/ipfs/QmbN7GjT8wgUYbQS7djN8Lqt19EjCa8VQtHTc5auBvvF2v"
                    }

                    if(data.asset.version == 2){
                      video_source = 'https://merchstore-api.cf-deployments.org/video/hoodiev2'
                      poster_source = "https://nftstorage.link/ipfs/QmcWnPb6KWEFLRH2ZFXjHQDxsDBEqwA3TxyNVnSJhqPc1B"
                    }

                    console.log(data.asset)

                    $("#asset_video").attr('src', video_source)

                    

                    var element = $("#video_element")

                    element[0].muted = true;
                    element[0].poster = poster_source
                    element[0].autoplay = true;
                    element[0].loop = true;
                    element[0].playsinline = true;
                    element[0].load();
                    element[0].play()
                    

                    $("#asset_attributes").show()
                    $("#asset_name").text(data.asset.name);
                    $("#product").text(data.asset.product);
                    $("#color").text(data.asset.color);
                    $("#description").text(data.asset.description);
                    $("#limited_quantity").text(data.asset.limited_quantity);
                    $("#apparel_technology").text(data.asset.apparel_technology);
                    $("#detailed_product_description").text(data.asset.detailed_product_description);
                    $("#certificate_authenticity").text(data.asset.certificate_authenticity);
                    $("#production_country").text(data.asset.production_country);
                    $("#about_authenticated_products").text(data.asset.about_authenticated_products);
                    $("#disclaimer").text(data.asset.disclaimer);
                    

                    

                    setTimeout(function(){
                      $("#video_element")[0].play()
                    }, 1000);
                    
                      
                  }else{
                    $("#verification_status").text('❌ ' + data.message)
                      $.each( data, function( key, value ) {
                        dom_el.append(key + " : " + value + "<br>")
                    });
                  }
  

  
              },
              error: function(err){
                  console.log("Device control failed");
                  console.log(err);
              },
              processData: true,
              type: 'POST',
              url: API_URL
          });
          
        }



    }else{
      window.location.replace("https://store.cardano.org");
    }



})